import type { OpencodeRouter } from "replo-publisher/src/trpc/routers/opencode";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: opencodeRouter,
  client: opencodeClient,
  utils: opencodeUtils,
  options: opencodeOptions,
} = createTrpcRouterConfig<OpencodeRouter>({
  path: "opencode",
  queryClient: getNamespacedQueryClient("opencode"),
});

export { opencodeClient, opencodeRouter, opencodeUtils, opencodeOptions };
